import React, { FC,useState,useEffect } from "react";
import { DEMO_CAR_LISTINGS } from "data/listings";
import { CarDataType } from "data/types";
//import Pagination from "shared/Pagination/Pagination";
import Heading2 from "components/Heading/Heading2";
import FixedDepartureCard from "./FixedDepartureCard";
import FixDepCard from "./FixDepCard";


export interface FixedDepartureCardGridProps {
  className?: string;
  data?: CarDataType[];
}

const DEMO_DATA: CarDataType[] = DEMO_CAR_LISTINGS.filter((_, i) => i < 12);

const FixedDepartureCardGrid: FC<FixedDepartureCardGridProps> = ({
  className = "",
  data = DEMO_DATA,
}) => {



  return (
    <div
      className={`nc-FixedDepartureCardGrid ${className}`}
      data-nc-id="FixedDepartureCardGrid"
    >
      <Heading2
        heading="Fixed Departure"
      />
      <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {(data as any)?.map((car:any) =>  {
            return <FixDepCard key={car.id} data={car}  size="default"/> 
      })}
      </div>
      {/* <div className="flex mt-16 justify-center items-center">
        <Pagination />
      </div> */}
    </div>
  );
};

export default FixedDepartureCardGrid;
